import {
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewContainerRef,
} from "@angular/core";
import * as _ from "lodash";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { FlowsService } from "../../flows.service";
import { ConnectorOptionMenuComponent } from "./connector-option-menu/connector-option-menu.component";

@Component({
  selector: "app-connector-option",
  templateUrl: "./connector-option.component.html",
  styleUrls: ["./connector-option.component.scss"],
})
export class ConnectorOptionComponent implements OnInit {
  @Input() data!: any;
  @Input() mode!: any;
  @Input() flowMenuViewContainerRef!: ViewContainerRef;
  @Output() onOptionsSelectChange =
    new EventEmitter<ConnectorOptionComponent | null>();
  @Input() onMenuOpenChange!: Subject<any>;
  @Input() onNodeOrConnectorMoved!: Subject<any>;
  @Input() onMenuSizeChange!: Subject<any>;
  touched = false;
  onMenuInstantiated = new Subject();
  @Input() internal!: boolean;

  private _selected: boolean = false;
  menuComponent!: ComponentRef<ConnectorOptionMenuComponent>;
  mutationObserver!: MutationObserver;
  private onComponentDestroy = new Subject();
  constructor(
    public element: ElementRef,
    private FlowsService: FlowsService,
    private factoryResolver: ComponentFactoryResolver,
  ) {}

  ngOnInit() {
    //console.log('CONNECTOR OPTION NG INIT', this.data)
    const factory = this.factoryResolver.resolveComponentFactory(
      ConnectorOptionMenuComponent,
    );
    this.menuComponent = factory.create(
      this.flowMenuViewContainerRef.parentInjector,
    );
    this.menuComponent.instance.data = this.data;
    this.menuComponent.instance.internal = this.internal;
    this.menuComponent.instance.onMenuSizeChange = this.onMenuSizeChange;

    this.flowMenuViewContainerRef.insert(this.menuComponent.hostView);

    this.menuComponent.instance.onConnectorMenuInstantiated
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(() => {
        this.onMenuInstantiated.next();
        this.onMenuInstantiated.complete();
      });

    this.onMenuInstantiated
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(() => {
        //On menu open/close
        this.menuComponent!.instance.onMenuOpenChange.pipe(
          takeUntil(this.onComponentDestroy),
        ).subscribe((menuOpenChange) => {
          this.onMenuOpenChange.next({
            type: "connector",
            menuOpenChange,
            element: this.element,
            menuElement: this.menuComponent!.instance.connectorMenuElement,
          });
        });
      });

    //On connector move
    this.mutationObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        //If style changes(we're assuming the connector moves) then emit change
        if (mutation.attributeName === "style") {
          this.onNodeOrConnectorMoved.next({
            type: "connector",
            component: this,
          });
        }
      });
    });

    this.mutationObserver.observe(this.element.nativeElement, {
      attributes: true,
      childList: true,
      characterData: true,
    });
  }

  ngAfterViewInit() {}

  ngOnDestroy() {
    if (this.menuComponent) {
      this.menuComponent.destroy();
    }
    if (!this.onMenuInstantiated.isStopped) {
      this.onMenuInstantiated.complete();
    }

    this.onComponentDestroy.next();
    this.onComponentDestroy.complete();
  }

  get selected() {
    return this._selected;
  }

  get conditionsValid() {
    if (this.menuComponent) {
      return this.menuComponent.instance.conditionsValid;
    }

    return false;
  }

  setSelected(selected: boolean) {
    this._selected = selected;
    if (this.menuComponent) {
      this.menuComponent.instance.selected = selected;
    }
  }

  openMenu($event: MouseEvent) {
    $event.stopPropagation();
    this.onOptionsSelectChange.emit(this);
    this.touched = true;
  }

  get conditionsDTO() {
    if (this.menuComponent) {
      return this.menuComponent.instance.conditionsDTO;
    }

    return null;
  }

  /** Full edge `data` payload for save (conditions + AI fields + is_follow_up). */
  get edgeDataDTO() {
    if (this.menuComponent) {
      return this.menuComponent.instance.edgeDataDTO;
    }
    return null;
  }
}
